import { render, staticRenderFns } from "./DepartureTabsTickets.vue?vue&type=template&id=716ad56c&scoped=true&"
import script from "./DepartureTabsTickets.vue?vue&type=script&lang=js&"
export * from "./DepartureTabsTickets.vue?vue&type=script&lang=js&"
import style0 from "./DepartureTabsTickets.vue?vue&type=style&index=0&id=716ad56c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716ad56c",
  null
  
)

export default component.exports